import {Button, message} from "antd";
import './check-button.style.less';
import {ComplianceManagerApi} from "../compliance-manager";

export function ComplianceCheckButton(props: { api: ComplianceManagerApi }){
    const { api } = props;
    const { run, loading } = api.complianceChecker;

    if (!api.allowRunCheck){
        return null;
    }

    function runCheck(){

        const hideMsg = message.loading('Running compliance check...', 0);

        run()
            .then(() => {
                hideMsg();
                message.success('Compliance check completed successfully.');
            })
            .catch((err) => {
                hideMsg();
                message.error('Failed to run compliance check: ' + err.message);
            });
    }

    return (
        <Button
            className="mc-compliance-manager-check-button"
            onClick={runCheck}
            loading={loading}
            icon="reload"
            type="primary"
        >
            Run Compliance Check
        </Button>
    );
}